
import { RevIllustration } from '@ds/components/Illustration'

export default {
  components: {
    RevIllustration,
  },
  props: {
    showArrow: {
      type: Boolean,
      default: false,
    },
  },
}
